import { AbstractControl, ValidationErrors } from '@angular/forms';

export const dateValidator = {


    validateFutureDate(control: AbstractControl): ValidationErrors | null {
        const fechaIngresada = new Date(control.value);
        const fechaActual = new Date();
        return fechaIngresada <= fechaActual ? null : { futureDate: true };
    },

    validateAdult(control: AbstractControl): ValidationErrors | null {
        const fechaIngresada = new Date(control.value);
        let adult = new Date();
        adult.setFullYear(adult.getFullYear() - 18)
        return fechaIngresada <= adult ? null : { notAdult: true };
    }
}

export const RutValidator = {

    validateRut(control: AbstractControl): ValidationErrors | null {
        const patternRut: RegExp = /^\d{7,8}$/;

        if (patternRut.test(control.value)) {
            // Verificar que no sea una secuencia de números iguales
            if (/(1{5,8}|2{5,8}|3{5,8}|4{5,8}|5{5,8}|6{5,8}|7{5,8}|8{5,8}|9{5,8})/.test(control.value)) return { rutInvalid: true }
        }
        return null
    },

    setDigitVerificator(rut: string): string {
        const patternRut: RegExp = /^\d{7,8}$/;
        let suma = 0;
        let multiplicador = 2;
        
        if(patternRut.test(rut)){
            for (let i = rut.length - 1; i >= 0; i--) {
                suma += parseInt(rut.charAt(i)) * multiplicador;
                multiplicador = multiplicador === 7 ? 2 : multiplicador + 1;
              }
            
              const residuo = suma % 11;
              let resultado = residuo === 0 ? '0' : (11 - residuo).toString();
            
              if (resultado === '10') {
                resultado = 'K';
              }

              return resultado 
        }
        return  "-"
        
    }
}

export const contactValidator = {

    validatePhone(control: AbstractControl): ValidationErrors | null {
        const patterPhone: RegExp = /^569\d{8}$/;
        if(!patterPhone.test(control.value)) return {phoneInvalid: true} 
        return null
    },

    validateMail(control: AbstractControl): ValidationErrors | null {
        const patterMail: RegExp = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,25}$/;
        if(!patterMail.test(control.value)) return {mailInvalid: true} 
        return null
    }
}

export const stringFormat = {
    upperCase(control: AbstractControl): void {
        if (typeof control.value === 'string') {
            control.setValue(control.value.trim().toUpperCase());
        }
    },

    capitalizeAll(control: AbstractControl): void {
        if (typeof control.value === 'string') {
            const titleCase = (str: string) => str.trim().toLowerCase().replace(/(^|\s)([a-záéíóúüñ])/g, c => c.toUpperCase());
            control.setValue(titleCase(control.value));
        }
    },

    lowerCase(control: AbstractControl): void {
        if (typeof control.value === 'string') {
            control.setValue(control.value.trim().toLowerCase());
        }
    },
 };